import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { Form, Icon, Modal, notification } from "antd";
import axios from "axios";

import FormAtendimento from "./components/FormAtendimento";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Atendimento = () => {
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");

    const validarExcluirAtendimento = () => {
        confirm({
            title: "Pretende remover este atendimento?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                excluirAtendimento();
            }
        });
    };

    const excluirAtendimento = () => {
        axios({
            method: "put",
            url: "/api/atendimento/excluir-atendimento",
            params: {
                atendimentoId: localStorage.getItem("atendimento")
            }
        })
            .then(() => {
                openNotificationWithIcon("success", "Atendimento excluído", "O registro foi removido com sucesso.");
                setRedirectLink(localStorage.getItem("link_voltar_calendario"));
                setRedirect(true);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao excluir o atendimento.");
            });
    };

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <div className="container container-body">
            <div className="curso-diario curso-diario-desktop" style={{ padding: "15px 15px 30px" }}>
                <div className="bloco-informacoes" style={{ border: "none", marginBottom: 0 }}>
                    <div className="info-aula">
                        <span>
                            <span className="titulo-aula">{localStorage.getItem("horario_detalhe_titulo")}</span>
                            <span>{localStorage.getItem("horario_detalhe_data_hora")}</span>
                        </span>
                        <span className="bloco-opcoes" style={{ gap: 10 }}>
                            <Link
                                to="#"
                                className="botao-icon-excluir botao-secundario-redondo"
                                title="Excluir"
                                style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                                onClick={validarExcluirAtendimento}
                            >
                                <Icon type="delete" />
                            </Link>
                            <Link
                                to={localStorage.getItem("link_voltar_calendario")}
                                className="botao-secundario botao-secundario-redondo"
                                title="Voltar"
                                style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                            >
                                <Icon type="arrow-left" />
                            </Link>
                        </span>
                    </div>
                </div>
                <div className="collapse-info-diario">
                    <FormAtendimento />
                </div>
            </div>
            <div className="curso-diario curso-diario-mobile">
                <div className="bloco-informacoes" style={{ border: "none", marginBottom: 0 }}>
                    <div className="info-aula">
                        <span>
                            <span className="titulo-aula">{localStorage.getItem("horario_detalhe_titulo")}</span>
                            <span>{localStorage.getItem("horario_detalhe_data_hora")}</span>
                        </span>
                        <span className="bloco-opcoes" style={{ gap: 10 }}>
                            <Link
                                to={localStorage.getItem("link_voltar_calendario")}
                                className="botao-secundario botao-secundario-redondo"
                                title="Voltar"
                                style={{
                                    marginRight: 10,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: 30,
                                    height: 30
                                }}
                            >
                                <Icon type="arrow-left" />
                            </Link>
                        </span>
                    </div>
                </div>
                <div className="collapse-info-diario">
                    <FormAtendimento />
                </div>
            </div>
        </div>
    );
};

export default Form.create({ name: "form-atendimento" })(Atendimento);
